<template>
    <div style="height: 100%;">
        <v-tabs v-model="active">
            <v-tab href="#tab-1" :key="1" v-if="activePtyType==='node' && fs.show('Node.Properties.View')" :disabled="fs.disabled('Node.Properties.View')">{{ $t( 'message.props_tb' ) }}</v-tab>
            <v-tab href="#tab-11" :key="11" v-if="activePtyType==='file' && fs.show('Document.Properties.View')" :disabled="fs.disabled('Document.Properties.View')">{{ $t( 'message.file_props_pnl_tb' ) }}</v-tab>
            <v-tab href="#tab-12" :key="12" v-if="activePtyType==='product' && fs.show('Product.Properties.View')" :disabled="fs.disabled('Product.Properties.View')">{{ $t( 'message.prod_props_pnl_tb' ) }}</v-tab>
            <v-tab href="#tab-2" :key="2" v-show="bomVis">
                <span v-if="!isReq">{{ $t( 'message.bom_tb' ) }}</span>
                <span v-else>{{ $t( 'message.bom_req_tb' ) }}</span>
                <ToolButton 
                    icon="push_pin" ghost
                    :class="bomFixed? '' : 'inactive-button'"
                    :tool-tip="bomFixed?'message.tab_menu_unfix':'message.tab_menu_fix'" 
                    v-on:click.stop="()=>{bomFixed = !bomFixed}"
                    />
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{bomVis = false; active = 'tab-1'; }"
                    />
            </v-tab>
            <v-tab href="#tab-3" :key="3" v-show="treeVis">
                {{ $t( 'message.node_tree_tb' ) }}
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{treeVis = false; active = 'tab-1'; }"
                />
            </v-tab>
            <v-tab href="#tab-44" :key="4" v-show="copyVis">
                <span style="overflow: hidden; text-overflow: ellipsis;">{{ globalState.curCopyFolderName }}</span>
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{copyVis = false; active = 'tab-1'; }"
                />
            </v-tab>
            <v-tab-item value="tab-1">
                <Split direction="vertical" :gutterSize="8" style="height:100%; display: flex; flex-direction: column;">
                    <SplitArea :size="fs.show('Node.UserProperties.View')?50:100" :minSize="0">
                        <pnl-props-view forSys="true" elemID="1"></pnl-props-view>
                    </SplitArea>
                    <SplitArea v-if="fs.show('Node.UserProperties.View')" :minSize="0">
                        <v-tabs v-model="active2" style="flex: 1 1 auto">
                            <v-tab href="#tab-4">{{ $t( 'message.user_props_tb' ) }}</v-tab>
                            <v-tab-item value="tab-4">
                                <pnl-props-view elemID="3"></pnl-props-view>
                            </v-tab-item>
                        </v-tabs>
                    </SplitArea>
                </Split>
            </v-tab-item>
            <v-tab-item value="tab-11">
                <Split direction="vertical" :gutterSize="8" style="height:100%; display: flex; flex-direction: column;">
                    <SplitArea :size="fs.show('Document.UserProperties.View')?50:100" :minSize="0">
                        <pnl-doc-props-view forSys="true" :data="fileData"></pnl-doc-props-view>
                    </SplitArea>
                    <SplitArea v-if="fs.show('Document.UserProperties.View')" :minSize="0">
                        <v-tabs v-model="active22" style="flex: 1 1 auto">
                            <v-tab href="#tab-41">{{ $t( 'message.user_props_tb' ) }}</v-tab>
                            <v-tab-item value="tab-41">
                                <pnl-doc-props-view :data="fileData"></pnl-doc-props-view>
                            </v-tab-item>
                        </v-tabs>
                    </SplitArea>
                </Split>
            </v-tab-item>
            <v-tab-item value="tab-12">
                <Split direction="vertical" :gutterSize="8" style="height:100%; display: flex; flex-direction: column;">
                    <SplitArea :size="fs.show('Product.UserProperties.View')?50:100" :minSize="0">
                        <pnl-prod-props-view forSys="true" :data="prodData"></pnl-prod-props-view>
                    </SplitArea>
                    <SplitArea v-if="fs.show('Product.UserProperties.View')" :minSize="0">
                        <v-tabs v-model="active23" style="flex: 1 1 auto">
                            <v-tab href="#tab-42">{{ $t( 'message.user_props_tb' ) }}</v-tab>
                            <v-tab-item value="tab-42">
                                <pnl-prod-props-view :data="prodData"></pnl-prod-props-view>
                            </v-tab-item>
                        </v-tabs>
                    </SplitArea>
                </Split>
            </v-tab-item>
            <v-tab-item value="tab-2">
                <tree-root-with-load-view :path="bomPath" :fixed="bomFixed"></tree-root-with-load-view>
            </v-tab-item>
            <v-tab-item value="tab-3">
                <tree-root-view :path="treePath"></tree-root-view>
            </v-tab-item>
             <v-tab-item value="tab-44">
                 <node-list-view></node-list-view>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import { Split, SplitArea } from 'vue-split-panel';

    import PnlProps from '../Pnl_Props.vue'
    import PnlDocProps from '../Pnl_Doc_Props.vue'
    import PnlProdProps from '../Pnl_Prod_Props.vue'
    import PnlFiles from '../Pnl_Files.vue'
    import TreeRoot from '../Tree/Root.vue'
    import TreeRootWithLoad from '../Tree/RootWithLoad.vue'
    import NodeList from '../NodeList.vue'
    import ToolButton from '../ToolButton.vue'
    
    import contextMenu from 'vue-context-menu'
    import FeaturesSet from "@/utils/features"

export default {
  name: 'home',
  data () 
  {
    return {
        fs: FeaturesSet,
        active: null,
        active2: null,
        active22: null,
        active23: null,
        activePtyType: "",
        bomVis: false,
        treeVis: false,
        copyVis: false,
        isReq: false,
        menuTab: null,
        treePath: null,
        bomPath: null,
        bomFixed: false,
        globalState: this.$globalStore.state,
        fileData: {},
        prodData: {}
    };
  },
  methods: {
    },
  components: {
      'pnl-props-view': PnlProps,
      'pnl-doc-props-view': PnlDocProps,
      'pnl-prod-props-view': PnlProdProps,
      //'pnl-files-view': PnlFiles, 
      'tree-root-view': TreeRoot,
      'tree-root-with-load-view': TreeRootWithLoad,
      'node-list-view': NodeList,
      'context-menu': contextMenu,
      'Split' : Split,
      'SplitArea': SplitArea,
      ToolButton
  },
  beforeMount: function()
  {
  },
  mounted: function()
  {
      var self = this;
      self.$eventBus.$on( 'showPathAsTree', function( path )
      {
          self.treePath = path;
          self.treeVis = true;
          self.active = 'tab-3';
      });
      self.$eventBus.$on( 'showBOMFromPath', function( path )
      {
          self.isReq = path[ path.length - 1 ].is_requirement;
          self.bomPath = path;
          self.bomVis = true;
          self.active = 'tab-2';
      });
      self.$eventBus.$on( 'selectedModel', function()
      {
          self.bomVis = false;
          self.bomFixed = false;
          self.treeVis = false;
          self.menuTab = null;
          self.active = 'tab-1';
          self.activePtyType = 'node';
          if( self.$refs.tabs )
              self.$refs.tabs.onResize(); 
      });
      
      self.$eventBus.$on( 'updateNode', function()
      {
          self.activePtyType = 'node';
          if( !self.bomFixed || self.active !== 'tab-2' ){
              self.active = 'tab-1';
          }
      });
      
      self.$eventBus.$on( 'updateFile', function( data )
      {
        self.activePtyType = 'file';
          if( !self.bomFixed || self.active !== 'tab-2' )
              self.active = 'tab-11';
          
          self.fileData = data;
      });
      
      self.$eventBus.$on( 'updateProd', function( data )
      {
        self.activePtyType = 'product';
          if( !self.bomFixed || self.active !== 'tab-2' )
              self.active = 'tab-12';

          self.prodData = data;
      });
      
      self.$eventBus.$on( 'showSelProps', function()
      {
        self.activePtyType = 'node';
          if( !self.bomFixed || self.active !== 'tab-2' )
              self.active = 'tab-1';
      });
      
      this.$eventBus.$emit( 'reInitState', {} );
  },
  beforeDestroy: function()
  {
      this.$eventBus.$off( 'showPathAsTree' );
      this.$eventBus.$off( 'showBOMFromPath' );
      this.$eventBus.$off( 'selectedModel' );
      
      this.$eventBus.$off( 'updateNode' );
      this.$eventBus.$off( 'updateFile' );
      this.$eventBus.$off( 'showSelProps' );
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
}
.v-tabs >>> div[role=tablist]{
    min-height: 48px;
}
.v-tabs >>> .v-window__container, .v-tabs >>> .v-window-item{
    height: 100%;
}

.v-tabs >>> .v-tabs-items{
    flex: 1 1 auto;
}
.inactive-button >>> i{
    color: #a6a6a6 !important;
    font-size: 16px !important;
}
</style>
